import { Navigation } from "../navigation"
import "./header.scss"

export const Header = () => (
  <header>
    <Navigation />
  </header>
)
